import React, { useEffect, useState } from "react";
// import { slideIntervalDuration } from './';

import Carousel from 'react-bootstrap/Carousel';
import 'bootstrap/dist/css/bootstrap.min.css';


const Banner = () => {
  const [slides, setSlides] = useState([]);
  // const [selectedSlide, setSelectedSlide] = useState(0);
  // const slideIntervalDuration = 2000; //

  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const school = process.env.REACT_APP_SCHOOL;
  useEffect(() => {
    fetch(`${baseUrl}/${school}/items/slider?fields=*.*.*`)
      .then(response => response.json())
      .then(data => {
        // Assuming the slides array is in the data property
        const apiSlides = data.data || [];
        console.log(apiSlides,"ApiSlides")
        // Set the slides state
        setSlides(apiSlides);
      })
      .catch(error => console.error('Error:', error));
      // const startSlideInterval = () => {
      //   return setInterval(() => {
      //     setSelectedSlide(prevSlide => (prevSlide + 1) % slides.length); // Infinite loop
      //   }, slideIntervalDuration);
      // };
  
      // Start the interval when the component mounts
      // const slideInterval = startSlideInterval();
  
      // Cleanup on unmount
      // return () => clearInterval(slideInterval);
  }, [slides.length,baseUrl,school]);

  return (
    <>
      {/* <div id="carouselExampleInterval" className="carousel slide" data-bs-ride="carousel">
        <div className="carousel-inner jaimataran">
          {slides.map((slide, index) => (
            <div
              key={index}
              className={`carousel-item ${index === selectedSlide ? 'active' : ''}`}
              data-bs-interval="5000"
            >
              <img src={slide?.slider_images?.data?.full_url.replace('http://', 'https://')} className="d-block w-100" alt={`Slide ${index}`} />
            </div>
          ))}
        </div>
        <button
          className="carousel-control-prev"
          type="button"
          data-bs-target="#carouselExampleInterval"
          data-bs-slide="prev"
          onClick={() => setSelectedSlide((selectedSlide - 1 + slides.length) % slides.length)}
        >
          <span className="carousel-control-prev-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Previous</span>
        </button>
        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#carouselExampleInterval"
          data-bs-slide="next"
          onClick={() => setSelectedSlide((selectedSlide + 1) % slides.length)}
        >
          <span className="carousel-control-next-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div> */}
    <div  className="carousel-container">
      <Carousel activeIndex={index} onSelect={handleSelect} interval={5000} className="jaimataran">
        {slides.map((slide, idx) => (
          <Carousel.Item key={idx} className="carousel-item">
            <img
              src={slide?.slider_images?.data?.full_url.replace('http://', 'https://')}
              alt={`Slide ${idx}`}
            />
          </Carousel.Item>
        ))}
      </Carousel>
    </div>
    </>
  );
};

export default Banner;
